import React from 'react';
import { Grid } from '@cxc/react-fpds-components';
import Dropdown from '../Dropdown/Dropdown';
import { residentialIncentivesData } from '../../state/GlobalState';
import { useAtom } from 'jotai';
import { ResidentialIncentiveApiData } from '../../types/ResidentialIncentivesDataType';
import {
    getUniqueGrantorsType,
    getUniqueGrantors,
    getUniqueApplicableToVehiclesType,
    getUniqueEligibleEquipments,
} from '../../utils/ResidentialIncentivesDataHelpers';
import {
    ResidentialDropDown,
    ResidentialInputFieldsContainerProps,
} from '../../types/ResidentialInputTypes';

const ResidentialInputFieldsContainer: React.FC<ResidentialInputFieldsContainerProps> = ({
    selectedResIncentiveGrantorType,
    setSelectedResIncentiveGrantorType,
    selectedResIncentiveElectricityProvider,
    setSelectedResIncentiveElectricityProvider,
    selectedResIncentiveApplicableVehicleType,
    setSelectedResIncentiveApplicableVehicleType,
    selectedResidentialEligibleEquipment,
    setSelectedResidentialEligibleEquipment,
}) => {
    const [residentialIncentives] =
        useAtom<ResidentialIncentiveApiData[]>(residentialIncentivesData);

    const residentialDropDowns: ResidentialDropDown[] = [
        {
            label: 'Grantor Type',
            tooltip: '',
            options: getUniqueGrantorsType(residentialIncentives),
            dataTestId: 'residential-incentive-grantor-type',
            onChange: setSelectedResIncentiveGrantorType,
            selected: selectedResIncentiveGrantorType,
        },
        {
            label: 'Electricity Provider',
            tooltip: '',
            options: getUniqueGrantors(residentialIncentives),
            dataTestId: 'electricity-provider',
            onChange: setSelectedResIncentiveElectricityProvider,
            selected: selectedResIncentiveElectricityProvider,
        },
        {
            label: 'Condition',
            tooltip: '',
            options: getUniqueApplicableToVehiclesType(residentialIncentives),
            dataTestId: 'available-to-select-as',
            onChange: setSelectedResIncentiveApplicableVehicleType,
            selected: selectedResIncentiveApplicableVehicleType,
        },
        {
            label: 'Equipment',
            tooltip: '',
            options: getUniqueEligibleEquipments(residentialIncentives),
            dataTestId: 'equipment-dropdown',
            onChange: setSelectedResidentialEligibleEquipment,
            selected: selectedResidentialEligibleEquipment,
        },
    ];

    return (
        <div>
            <Grid>
                {residentialDropDowns.map((dropdown) => (
                    <Grid.Item key={dropdown.label} xl={2} l={3} m={4} s={4}>
                        <Dropdown
                            label={dropdown.label}
                            tooltip={dropdown.tooltip}
                            options={dropdown.options}
                            dataTestId={dropdown.dataTestId}
                            onChange={dropdown.onChange}
                            selected={dropdown.selected}
                        />
                    </Grid.Item>
                ))}
            </Grid>
        </div>
    );
};

export default ResidentialInputFieldsContainer;
